import React from 'react';
import Select, { components } from 'react-select';
import "./selectCoins.css"

const { Option, SingleValue } = components;

const IconOption = (props) => (
  <Option {...props}>
    {
      props.data && props.data.symbol && props.data.symbol !== "" &&
      <img
        src={require('../../CryptoIcons/' + props.data.symbol + '.svg')}
        style={{ width: "20px", marginRight: '4px'}}
        alt={props.data.name}
      />
    }
    <span>{props?.data?.name}</span>
  </Option>
);

const ValueOption = (props) => (
  <SingleValue style={{display: 'flex', alignItems: 'center'}} {...props}>
    {
      props.data && props.data.symbol && props.data.symbol !== "" &&
      <img
        src={require('../../CryptoIcons/' + props.data.symbol + '.svg')}
        style={{ width: "25px", marginRight: '4px'}}
        alt={props.data.name}
      />
    }
    {
      props?.data?.symbol === 'tdc' ? 
      <div style={{color: "#2E2C2C", fontSize: '23px'}}>{props.data.name}</div>
      :
      <div style={{color: "#2E2C2C", fontSize: '23px'}}>{props.data.name} <span style={{color: "#909090"}}>{props?.data?.symbol?.toUpperCase()}</span></div>
    }
  </SingleValue>
);

const SelectCoins = ({
  onChange,
  value,
  options,
  placeholder = "",
}) => {

  return (
    <Select
      id='coins-select'
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={false}
      isSearchable={false}
      isClearable={false}
      components={{ Option: IconOption, SingleValue : ValueOption }}
    />
  )
}

export default SelectCoins;
